// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/nominativi/:id',
    requestBody: null,
    response: '{"id":"number","codice":"string","ragioneSociale":"string","nome":"string","cognome":"string","tipoSoggetto":"string","partitaIva":"string","codiceFiscale":"string","codiceSDI":"string","pec":"string","telefono":"string","emailPrincipale":"string","sito":"string","isCliente":"boolean","isFornitore":"boolean","disattivato":"boolean","bloccato":"boolean","societa":"object","indirizzi":"array"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
